module.exports = __webpack_public_path__ + "static/media/back_image.43549f08.png";